import { render } from "./MiniMetodeSearchPage.vue?vue&type=template&id=0b9745db&scoped=true"
import script from "./MiniMetodeSearchPage.vue?vue&type=script&lang=js"
export * from "./MiniMetodeSearchPage.vue?vue&type=script&lang=js"

import "./MiniMetodeSearchPage.vue?vue&type=style&index=0&id=0b9745db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9745db"]])

export default __exports__